import React, { useState } from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/Title";
import { PrivateCloudPrice } from "../private-cloud-price";
import { ConsultModal } from "../../components/ConsultModal";

export const PrivateCloudResource = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  return (
    <section className="private-cloud-resource">
      <div className="inner">
        <div className="resource-content-warp">
          <a
            className="resource-card"
            href="//docs.authing.cn/v2/guides/deployment/ "
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="resource-card-icon">
              <img
                src="//files.authing.co/authing-website/private-cloud-download-default.png"
                alt=""
                className="default"
              />
              <img
                src="//files.authing.co/authing-website/private-cloud-download.png"
                alt=""
                className="checked"
              />
            </div>
            <div className="resource-card-content-warp">
              <div className="resource-card-title">
                {t("solution.privateCloud.resource.mirror.title")}
              </div>
              <div className="resource-card-content">
                {t("solution.privateCloud.resource.mirror.content")}
              </div>
              <a
                className="resource-card-button"
                href="//docs.authing.cn/v2/guides/deployment/ "
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("solution.privateCloud.resource.docs.button-link")}
              </a>
            </div>
          </a>
          <a
            className="resource-card"
            href="//docs.authing.cn/v2/quickstarts/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="resource-card-icon">
              <img
                src="//files.authing.co/authing-website/private-cloud-docs-default.png"
                alt=""
                className="default"
              />
              <img
                src="//files.authing.co/authing-website/private-cloud-docs-new.png"
                alt=""
                className="checked"
              />
            </div>
            <div className="resource-card-content-warp">
              <div className="resource-card-title">
                {t("solution.privateCloud.resource.docs.title")}
              </div>
              <div className="resource-card-content">
                {t("solution.privateCloud.resource.docs.content")}
              </div>
              <a
                className="resource-card-button"
                href="//docs.authing.cn/v2/quickstarts/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("solution.privateCloud.resource.docs.button-link")}
              </a>
            </div>
          </a>
        </div>
        <h3 className="block-title">
          {t("solution.privateCloud.resource.price-title")}
        </h3>
        <PrivateCloudPrice />
        <ConsultModal {...{ visible, setVisible }} />
      </div>
    </section>
  );
};
